// @flow
import ConfigContainer from './containers/ConfigContainer';

export default ConfigContainer;